module.exports = __webpack_public_path__ + "img/header-memoireRingsHalfSetMemories@2x.657bf5d.webp";